import { isDesktop, isMobile, isTablet } from 'react-device-detect';

export interface PaginatedData {
    previous: string;
    next: string;
}

export const getDeviceType = (): string => {
    if (isDesktop) {
        return 'desktop';
    }
    if (isTablet) {
        return 'tablet';
    }
    if (isMobile) {
        return 'mobile';
    }
    return 'unknown';
};

export const indexBy = <T>(arr: T[], fn: (t: T) => string): { [key: string]: T } =>
    arr.reduce((acc, elem) => {
        return { ...acc, [fn(elem)]: elem };
    }, {});
